<template>
  <div class="sidebar" :class="{ collapsed: isCollapsed }">
    <!-- Logo区域和折叠按钮 -->
    <div class="sidebar-header">
      <div class="logo">
        <el-icon class="logo-icon" color="#41D2A5">
          <svg viewBox="0 0 48 48" fill="currentColor">
            <path fill-rule="evenodd" clip-rule="evenodd" 
              d="M39.475 21.6262C40.358 21.4363 40.6863 21.5589 40.7581 21.5934C40.7876 21.655 40.8547 21.857 40.8082 22.3336C40.7408 23.0255 40.4502 24.0046 39.8572 25.2301C38.6799 27.6631 36.5085 30.6631 33.5858 33.5858C30.6631 36.5085 27.6632 38.6799 25.2301 39.8572C24.0046 40.4502 23.0255 40.7407 22.3336 40.8082C21.8571 40.8547 21.6551 40.7875 21.5934 40.7581C21.5589 40.6863 21.4363 40.358 21.6262 39.475C21.8562 38.4054 22.4689 36.9657 23.5038 35.2817C24.7575 33.2417 26.5497 30.9744 28.7621 28.762C30.9744 26.5497 33.2417 24.7574 35.2817 23.5037C36.9657 22.4689 38.4054 21.8562 39.475 21.6262ZM4.41189 29.2403L18.7597 43.5881C19.8813 44.7097 21.4027 44.9179 22.7217 44.7893C24.0585 44.659 25.5148 44.1631 26.9723 43.4579C29.9052 42.0387 33.2618 39.5667 36.4142 36.4142C39.5667 33.2618 42.0387 29.9052 43.4579 26.9723C44.1631 25.5148 44.659 24.0585 44.7893 22.7217C44.9179 21.4027 44.7097 19.8813 43.5881 18.7597L29.2403 4.41187C27.8527 3.02428 25.8765 3.02573 24.2861 3.36776C22.6081 3.72863 20.7334 4.58419 18.8396 5.74801C16.4978 7.18716 13.9881 9.18353 11.5858 11.5858C9.18354 13.988 7.18717 16.4978 5.74802 18.8396C4.58421 20.7334 3.72865 22.6081 3.36778 24.2861C3.02574 25.8765 3.02429 27.8527 4.41189 29.2403Z" />
          </svg>
        </el-icon>
        <h1 class="logo-text" v-show="!isCollapsed">ArkSus</h1>
      </div>
      <el-tooltip :content="isCollapsed ? '展开导航' : '折叠导航'" placement="right">
        <el-button 
          :icon="isCollapsed ? Expand : Fold" 
          circle 
          size="small" 
          @click="toggleCollapse"
          class="collapse-button"
        />
      </el-tooltip>
    </div>

    <!-- 导航菜单 -->
    <nav class="sidebar-nav">
      <el-menu
        :default-active="$route.path"
        router
        class="sidebar-menu"
        :collapse="isCollapsed"
        background-color="transparent"
        text-color="#666666"
        active-text-color="#41D2A5"
      >
        <el-tooltip content="首页看板" placement="right" :disabled="!isCollapsed">
          <el-menu-item index="/dashboard">
            <el-icon><House /></el-icon>
            <span>首页看板</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="AI助理团队" placement="right" :disabled="!isCollapsed">
          <el-menu-item index="/agent-management">
            <el-icon><Avatar /></el-icon>
            <span>AI助理团队</span>
          </el-menu-item>
        </el-tooltip>


        <el-tooltip content="绿色运营" placement="right" :disabled="!isCollapsed">
          <el-sub-menu index="/green-operations">
            <template #title>
              <el-icon><ShoppingBag /></el-icon>
              <span>绿色运营</span>
            </template>
            <el-menu-item index="/green-operations/health-safety">健康安全</el-menu-item>
            <el-menu-item index="/green-operations/green-design">绿色设计</el-menu-item>
            <el-menu-item index="/green-operations/carbon-management">能碳管理</el-menu-item>
            <el-menu-item index="/green-operations/supply-chain">绿色供应链</el-menu-item>
            <el-menu-item index="/green-operations/product-responsibility">产品责任</el-menu-item>
          </el-sub-menu>
        </el-tooltip>

        <el-tooltip content="洞察分析" placement="right" :disabled="!isCollapsed">
          <el-menu-item index="/insights">
            <el-icon><TrendCharts /></el-icon>
            <span>洞察分析</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="事件汇报" placement="right" :disabled="!isCollapsed">
          <el-menu-item index="/incident-reports">
            <el-icon><Warning /></el-icon>
            <span>事件汇报</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="改进行动" placement="right" :disabled="!isCollapsed">
          <el-menu-item index="/improvement-actions">
            <el-icon><Flag /></el-icon>
            <span>改进行动</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="模版中心" placement="right" :disabled="!isCollapsed">
          <el-menu-item index="/templates">
            <el-icon><Document /></el-icon>
            <span>模版中心</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="培训" placement="right" :disabled="!isCollapsed">
          <el-menu-item index="/training">
            <el-icon><ReadingLamp /></el-icon>
            <span>培训</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="设置" placement="right" :disabled="!isCollapsed">
          <el-menu-item index="/settings">
            <el-icon><Setting /></el-icon>
            <span>设置</span>
          </el-menu-item>
        </el-tooltip>
      </el-menu>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import {
  House,
  Avatar,
  Lightning,
  ShoppingBag,
  TrendCharts,
  Warning,
  Flag,
  Document,
  ReadingLamp,
  Setting,
  Expand,
  Fold
} from '@element-plus/icons-vue'

// 折叠状态管理
const isCollapsed = ref(false)

const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value
}

// 监听来自AgentAvatars组件的折叠事件
const handleCollapseEvent = (event: Event) => {
  if (event.type === 'collapse-sidebar') {
    isCollapsed.value = true
  } else if (event.type === 'expand-sidebar') {
    isCollapsed.value = false
  }
}

// 生命周期管理
onMounted(() => {
  window.addEventListener('collapse-sidebar', handleCollapseEvent)
  window.addEventListener('expand-sidebar', handleCollapseEvent)
})

onUnmounted(() => {
  window.removeEventListener('collapse-sidebar', handleCollapseEvent)
  window.removeEventListener('expand-sidebar', handleCollapseEvent)
})
</script>

<style lang="scss" scoped>
.sidebar {
  width: 256px;
  height: 100vh;
  background: white;
  border-right: 1px solid #e6e6e6;
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  // 与协作项目面板的紧凑对齐优化
  @media (min-width: 1025px) {
    width: 240px; // 稍微减小宽度以提供更多空间给主内容区域
  }
  
  &.collapsed {
    width: 80px;
    
    .sidebar-header {
      padding: 16px;
      
      .logo {
        justify-content: center;
        
        .logo-text {
          opacity: 0;
          width: 0;
          overflow: hidden;
        }
      }
      
      .collapse-button {
        position: absolute;
        top: 18px;
        right: -12px;
        z-index: 10;
        background: white;
        border: 1px solid #e6e6e6;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        
        @media (min-width: 1025px) {
          top: 16px;
        }
      }
    }
    
    .sidebar-nav {
      .sidebar-menu {
        :deep(.el-menu-item),
        :deep(.el-sub-menu) {
          margin: 0 8px 4px;
          justify-content: center;
          
          .el-icon {
            margin-right: 0 !important;
          }
        }
        
        :deep(.el-sub-menu) {
          .el-sub-menu__title {
            justify-content: center;
            
            .el-sub-menu__icon-arrow {
              display: none;
            }
          }
        }
      }
    }
  }

  .sidebar-header {
    padding: 18px 20px; // 减少内边距以实现更紧凑的排列
    border-bottom: 1px solid #f3f3f3;
    position: relative;
    
    @media (min-width: 1025px) {
      padding: 16px 18px; // 进一步缩小在大屏上的内边距
    }

    .logo {
      display: flex;
      align-items: center;
      gap: 12px;
      transition: all 0.3s ease;

      .logo-icon {
        font-size: 24px;
        flex-shrink: 0;
      }

      .logo-text {
        font-size: 22px; // 稍微减小字体以节省空间
        font-weight: 600;
        color: #41D2A5;
        margin: 0;
        transition: all 0.3s ease;
        white-space: nowrap;
        
        @media (min-width: 1025px) {
          font-size: 20px;
        }
      }
    }
    
    .collapse-button {
      position: absolute;
      top: 18px;
      right: 20px;
      transition: all 0.3s ease;
      
      @media (min-width: 1025px) {
        top: 16px;
        right: 18px;
      }
      
      &:hover {
        background: #f3f4f6;
        transform: scale(1.1);
      }
    }
  }

  .sidebar-nav {
    flex: 1;
    padding: 12px 0; // 减少顶部和底部内边距
    overflow: hidden;
    
    @media (min-width: 1025px) {
      padding: 10px 0;
    }

    .sidebar-menu {
      border-right: none;
      transition: all 0.3s ease;

      :deep(.el-menu-item) {
        margin: 0 10px 3px; // 减小间距实现更紧凑的垂直排列
        border-radius: 8px;
        height: 40px; // 稍微减小高度
        line-height: 40px;
        
        @media (min-width: 1025px) {
          height: 38px;
          line-height: 38px;
          margin: 0 8px 2px;
        }
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        position: relative;
        overflow: hidden;

        &:hover {
          background-color: #f3f4f6;
          transform: translateX(4px);
        }

        &.is-active {
          background: linear-gradient(135deg, #eafaf5 0%, #f0fdf4 100%);
          color: #41D2A5;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(65, 210, 165, 0.15);
          
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 4px;
            background: linear-gradient(135deg, #41D2A5, #64D241);
            border-radius: 0 2px 2px 0;
          }
        }
        
        .el-icon {
          font-size: 20px;
          transition: all 0.3s ease;
        }
        
        span {
          transition: all 0.3s ease;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      :deep(.el-sub-menu) {
        .el-sub-menu__title {
          margin: 0 10px 3px; // 与菜单项保持一致的紧凑间距
          border-radius: 8px;
          height: 40px;
          line-height: 40px;
          
          @media (min-width: 1025px) {
            height: 38px;
            line-height: 38px;
            margin: 0 8px 2px;
          }
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          overflow: hidden;

          &:hover {
            background-color: #f3f4f6;
            transform: translateX(4px);
          }
          
          .el-icon {
            font-size: 20px;
            transition: all 0.3s ease;
          }
          
          span {
            transition: all 0.3s ease;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .el-menu {
          background-color: transparent;

          .el-menu-item {
            padding-left: 48px !important;
            height: 40px;
            line-height: 40px;
            margin: 0 12px 2px;
            
            &:hover {
              background-color: rgba(65, 210, 165, 0.05);
            }
          }
        }
        
        &.is-active {
          .el-sub-menu__title {
            background: linear-gradient(135deg, #eafaf5 0%, #f0fdf4 100%);
            color: #41D2A5;
            font-weight: 500;
          }
        }
      }
    }
  }
}

// 折叠动画优化
@media (prefers-reduced-motion: no-preference) {
  .sidebar {
    .logo-text {
      animation: fadeIn 0.3s ease 0.1s both;
    }
    
    &.collapsed .logo-text {
      animation: fadeOut 0.2s ease both;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-10px);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .sidebar {
    width: 256px;
    
    &.collapsed {
      width: 80px;
    }
  }
}
</style>